
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseItemsBOMGrid extends _Ext.GridBase<PurchaseItemsBOMRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseItemsBOM'; }
        protected getDialogType() { return PurchaseItemsBOMDialog; }
        protected getIdProperty() { return PurchaseItemsBOMRow.idProperty; }
        protected getInsertPermission() { return PurchaseItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseItemsBOMRow.localTextPrefix; }
        protected getService() { return PurchaseItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}